module.exports = __webpack_public_path__ + "static/media/20.453d9a6b.jpg";